import {
  IconButton,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Tooltip,
} from '@vimeo/bokeh';
import { Filter } from '@vimeo/bokeh-icons';
import { useCapability } from '@vimeo/core/hooks/use-capability';

import { T } from '../../translations';
import { FilterOptions } from '../../types';

type CommentFilterProps = {
  filterOptions: FilterOptions;
  updateFilterOptions: (newFilterOption: FilterOptions) => void;
  onUnreadFilterToggle?: (isUnreadActive: boolean) => void;
  showOnlyUnread?: boolean;
  isLoggedOut: boolean;
};

export const CommentFilters = ({
  filterOptions,
  updateFilterOptions,
  onUnreadFilterToggle,
  showOnlyUnread,
  isLoggedOut,
}: CommentFilterProps) => {
  const { capabilities } = useCapability(['hasCommentsTrackingEnabled']);
  const hasCommentsTrackingEnabled = capabilities?.hasCommentsTrackingEnabled;

  const filterSelected =
    filterOptions.userType != 'everyone' || filterOptions.mentionAndReplies || showOnlyUnread;
  return (
    <Menu>
      <Tooltip placement="top" label={T.Filter}>
        <MenuButton
          onFocus={(e) => e.preventDefault()}
          as={IconButton}
          variant={filterSelected ? 'primary' : 'tertiary'}
          size="sm"
          aria-label="Filter comments"
          icon={<Filter />}
        />
      </Tooltip>
      <MenuList background="background">
        {!isLoggedOut && (
          <>
            <MenuOptionGroup
              title={`${T.ShowFrom}:`}
              textColor="text-secondary"
              defaultValue="everyone"
              value={filterOptions.userType}
              onChange={(value) =>
                updateFilterOptions({ userType: value as FilterOptions['userType'] })
              }
            >
              <MenuItemOption value="everyone">{T.Everyone}</MenuItemOption>
              <MenuItemOption value="team">{T.OnlyFromTeam}</MenuItemOption>
              <MenuItemOption value="non_team">{T.OnlyGuests}</MenuItemOption>
            </MenuOptionGroup>
            <MenuDivider />
          </>
        )}
        <MenuOptionGroup value={filterOptions.mentionAndReplies?.toString()}>
          <MenuItemOption
            value="true"
            onClick={() =>
              updateFilterOptions({ mentionAndReplies: !filterOptions.mentionAndReplies })
            }
          >
            {T.MentionsAndReplies}
          </MenuItemOption>
        </MenuOptionGroup>
        {hasCommentsTrackingEnabled && (
          <>
            <MenuOptionGroup value={showOnlyUnread?.toString()}>
              <MenuItemOption value="true" onClick={() => onUnreadFilterToggle?.(!showOnlyUnread)}>
                {T.Unread}
              </MenuItemOption>
            </MenuOptionGroup>
          </>
        )}
      </MenuList>
    </Menu>
  );
};
